
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/calendar",
      function () {
        return require("private-next-pages/investor/calendar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/calendar"])
      });
    }
  